// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2vaup","homeHeader":"Header_homeHeader__6bon6","title":"Header_title__oQWxI","homeTitle":"Header_homeTitle__CSUUa","btnPrimary":"Header_btnPrimary__abtIO"};